import {Component, Input} from '@angular/core';

export enum TOOLTIP_POSITION {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom'
}
export enum CARET_POSITION {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center'
}

@Component({
  selector: 'beaconstac-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {
  TOOLTIP_POSITION = TOOLTIP_POSITION;

  checkPosition() {
    if (!this.isInViewport(document.getElementById('tooltip-1'))) {
      switch (this.tooltipPosition) {
        case TOOLTIP_POSITION.TOP:
          this.tooltipPosition = TOOLTIP_POSITION.BOTTOM;
          break;
        case TOOLTIP_POSITION.BOTTOM:
          this.tooltipPosition = TOOLTIP_POSITION.TOP;
          break;
        case TOOLTIP_POSITION.LEFT:
          this.tooltipPosition = TOOLTIP_POSITION.RIGHT;
          break;
        case TOOLTIP_POSITION.RIGHT:
          this.tooltipPosition = TOOLTIP_POSITION.LEFT;
          break;
      }
    }
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top - 10 >= 0 &&
      rect.left - 10 >= 0 &&
      rect.bottom + 200 <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right + 200 <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }


  /**
   * elementClass
   *
   * @required
   */
  @Input()
  elementClass: any;

  /**
   * ToolTip text
   *
   * @required
   */
  @Input()
  content: string;

  /**
   * TOOLTIP_POSITION
   */
  @Input()
  tooltipPosition: TOOLTIP_POSITION = TOOLTIP_POSITION.TOP;

  /**
   * CARET_POSITION
   */
  @Input()
  caretPosition: CARET_POSITION = CARET_POSITION.LEFT;

  /**
   * Color for tooltip
   */
  @Input()
  color: string = '';

  /**
   * Image for tooltip
   */
  @Input()
  image: string;

  /**
   * Image for tooltip
   */
  @Input()
  width: string;
}
